import { render, staticRenderFns } from "./ContractItems.vue?vue&type=template&id=c36f9fba&scoped=true&"
import script from "./ContractItems.vue?vue&type=script&lang=js&"
export * from "./ContractItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36f9fba",
  null
  
)

export default component.exports